export default __webpack_public_path__ + "static/media/apple.a970c519.svg";